import axios from "axios";
const getAllDepositos = async () => {
  return [
    {
      idDeposito: 1,
      descripcion: "PLAYA DEP INTERNO",
      idEstacion: 1,
      domicilioEntrega: "",
    },
    {
      idDeposito: 2,
      descripcion: "FULL VENTAS",
      idEstacion: 1,
      domicilioEntrega: "",
    },
    {
      idDeposito: 3,
      descripcion: "GENERAL",
      idEstacion: 1,
      domicilioEntrega: "",
    },
    {
      idDeposito: 4,
      descripcion: "PLAYA VENTAS",
      idEstacion: 1,
      domicilioEntrega: "",
    },
    {
      idDeposito: 5,
      descripcion: "PLAYA DEP SEMILLERO",
      idEstacion: 1,
      domicilioEntrega: "",
    },
    {
      idDeposito: 6,
      descripcion: "FULL DEP INTERNO",
      idEstacion: 1,
      domicilioEntrega: "",
    },
  ];
};

const realizarTransferenciaStock = async transferenciaData => {
  const nic = "http://pabloi.caldenoil.com:5800";
  const token = localStorage.getItem("token");

  try {
    const body = {
      ...transferenciaData,
      nic,
      token,
    };

    const { data } = await axios.post(`https://caldenon-proxy.azurewebsites.net/api/Depositos/RealizarTransferenciaStock`, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  } catch (error) {
    console.error("Error en realizarTransferenciaStock:", error.response?.data || error.message);
    throw error;
  }
};

const realizarIngresoStock = async ingresoData => {
  const nic = "http://pabloi.caldenoil.com:5800";
  const token = localStorage.getItem("token");

  try {
    const body = {
      ...ingresoData,
      nic,
      token,
    };

    const { data } = await axios.post(`https://caldenon-proxy.azurewebsites.net/api/Depositos/RealizarIngresoStock`, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  } catch (error) {
    console.error("Error en realizarIngresoStock:", error.response?.data || error.message);
    throw error;
  }
};

const getNumeroYPrefijo = async idMotivoStock => {
  const nic = "http://pabloi.caldenoil.com:5800";
  const token = localStorage.getItem("token");

  try {
    const headers = { "Content-Type": "application/json" };
    const body = { nic, token, idMotivoStock };

    const { data } = await axios.post(`https://caldenon-proxy.azurewebsites.net/api/Depositos/ObtenerNumeroYPrefijo`, body, { headers });
    return data;
  } catch (error) {
    console.error("Error en getNumeroYPrefijo:", error.response?.data || error.message);
    throw error;
  }
};

const depositos = {
  getAllDepositos,
  realizarTransferenciaStock,
  realizarIngresoStock,
  getNumeroYPrefijo,
};

export default depositos;
